import React from "react"
import PropTypes from "prop-types"
import { StyledField } from "./styles"

const NumberField = ({ handleInputChange, ...rest }) => {
  const { name, value, simpleForm } = rest

  const onChange = (value) => {
    if (handleInputChange !== undefined) handleInputChange(name, value)
  }

  return (
    <StyledField
      type="number"
      onWheel={(event) => event.target.blur()}
      onInput={(number) => onChange(number.target.value)}
      defaultValue={value}
      {...rest}
    />
  )
}

NumberField.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  invalid: PropTypes.bool
}

NumberField.defaultProps = {
  handleInputChange: undefined,
  invalid: false
}

export default NumberField
